import ListErrors from './ListErrors'
import React from 'react'
import agent from '../agent'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import {
  UPDATE_FIELD_AUTH,
  LOGIN,
  LOGIN_PAGE_UNLOADED,
  REDIRECT
} from '../constants/actionTypes'

const mapStateToProps = state => ({
  ...state.auth,
  redirectTo: state.common.redirectTo
})

const mapDispatchToProps = dispatch => ({
  onChangeEmail: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'email', value }),
  onChangePassword: value =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: 'password', value }),
  onSubmit: (email, password) =>
    dispatch({ type: LOGIN, payload: agent.Auth.login(email, password) }),
  onUnload: () =>
    dispatch({ type: LOGIN_PAGE_UNLOADED }),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class Login extends React.Component {
  constructor() {
    super()
    this.changeEmail = ev => this.props.onChangeEmail(ev.target.value)
    this.changePassword = ev => this.props.onChangePassword(ev.target.value)
    this.submitForm = (email, password) => ev => {
      ev.preventDefault()
      this.props.onSubmit(email, password)
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect()
      // this.props.onUnload()
    }
  }
  // componentWillUnmount() {
  //   this.props.onUnload()
  // }

  render() {
    const email = this.props.email
    const password = this.props.password
    return (
      <div className="notice">
        <h1>Sign In</h1>
        <ListErrors errors={this.props.errors} />
        <form onSubmit={this.submitForm(email, password)}>
          <fieldset className="form">
            <fieldset className="form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={this.changeEmail} />
            </fieldset>

            <fieldset className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={this.changePassword} />
            </fieldset>

            <fieldset className="form-group">
              <button
                type="submit"
                disabled={this.props.inProgress}>
                Sign in
              </button>
            </fieldset>
          </fieldset>
        </form>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js